<template>


  <div>  
    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Active Report</el-breadcrumb-item>
      <el-breadcrumb-item>活跃新老设备</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div style="margin-bottom: 20px; text-align: right; padding-right: 80px;">

  <el-radio-group v-model="radioCycle">
    <el-radio-button label="weekly">weekly</el-radio-button>
    <el-radio-button label="monthly">monthly</el-radio-button>

  </el-radio-group>
  
  <el-button type="primary" @click="exportCsv"   style="margin-left: 80px;" >下载 CSV</el-button>
</div>



    <el-table :data="tableData" stripe style="width: 100%" height="950" :default-sort = "{prop: 'title', order: 'descending'}">

      <el-table-column prop="title" label="日期"  width="180" sortable>
      </el-table-column>

      <el-table-column prop="active_count" label="活跃设备数">
      </el-table-column>
      <el-table-column prop="active_old" label="活跃老设备">
      </el-table-column>
      <el-table-column prop="active_old_rate" label="老设备占比">
      </el-table-column>
      <el-table-column prop="active_old_xbike" label="老xbike">
      </el-table-column>
      <el-table-column prop="active_old_litbike" label="老litbike">
      </el-table-column>
      <el-table-column prop="active_old_boombike" label="老boombike">
      </el-table-column>
      <el-table-column prop="active_old_boombasic" label="老boombasic">
      </el-table-column>
      <el-table-column prop="active_old_ebike" label="老ebike">
      </el-table-column>
      <el-table-column prop="active_old_other" label="老other">
      </el-table-column>

      <el-table-column prop="active_new" label="活跃新设备">
      </el-table-column>
      <el-table-column prop="active_new_rate" label="新设备占比">
      </el-table-column>
      <el-table-column prop="active_new_xbike" label="新xbike">
      </el-table-column>
      <el-table-column prop="active_new_litbike" label="新litbike">
      </el-table-column>
      <el-table-column prop="active_new_boombike" label="新boombike">
      </el-table-column>
      <el-table-column prop="active_new_boombasic" label="新boombasic">
      </el-table-column>
      <el-table-column prop="active_new_ebike" label="新ebike">
      </el-table-column>
      <el-table-column prop="active_new_other" label="新other">
      </el-table-column>   





    </el-table>




  </div>
</template>
  
<script>

import { exportToCsv } from '@/utils/exportToCsv';

export default {
  data() {
    return {
      tableData: [],
      radioCycle: this.$route.query.cycle || 'weekly', // 默认值为 'weekly'
    }
  },

watch: {
    // 监听路由变化
    '$route.query.cycle'(newCycle) {
      this.radioCycle = newCycle;
      this.getData()
    },
    // 监听 radioCycle 变化
    radioCycle(newCycle) {
      // 更新URL中的 cycle 参数
      this.$router.push({ query: { ...this.$route.query, cycle: newCycle } });
      this.getData()
    },
  },
  created: function () {
    //注意回调函数的作用域!!!
  },

  methods:{
    async  getData(){
   
      this.tableData = []

      let res = await this.$http.get("/da/active_new_old/"+this.radioCycle)  //activityWeekly
      this.tableData = res.data
       // console.log(res.data)
    },

    exportCsv(){
      exportToCsv(this.tableData,"activeDeviceNewOld.csv")
    },

  },
  formatDecimal(value) {
    return parseFloat(value).toFixed(2);
  },
  mounted() {
    // 如果路由中有 cycle 参数，则在组件挂载时同步到 radioCycle
    if (this.$route.query.cycle) {
      this.radioCycle = this.$route.query.cycle;
    }
    this.getData()
  },



}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
  